@if (team?.isPrivate) {
    <span>
        <i [ngClass]="iconClass"
           adaptTooltip="Only accessible to members of the private team and coaches"
           [tooltipEnabled]="showTooltip"></i>
    </span>
}
